<script lang="ts">
	import PageHero from "@components/PageHero.svelte";
	import ProductCategoryHeros from "@components/ProductCategoryHeros.svelte";
	import Layout from "@components/layout/Layout.svelte";
	import type { ProductsProps } from "./ProductsProps.js";

	const { subcategories }: ProductsProps = $props();
</script>

<Layout>
	<div class="whitespace-pre-line"></div>

	<PageHero
		headline="Diagnostické a výzkumné nl[[]] produkty pro laboratoře"
		description="Společnost INTIMEX s. r. o. se specializuje na dodávku špičkových produktů pro oblast cytogenetiky, molekulární biologie a výzkumu biomarkerů oxidačního stresu. Nabídka zahrnuje širokou škálu FISH sond, kultivačních médií, testovacích souprav, pomocných reagencií, laboratorního vybavení a specializovaných chemikálií. Díky individuálnímu přístupu k zákazníkům firma zajišťuje řešení i pro nejnáročnější aplikace v oblasti genetické diagnostiky a bioanalýzy."
		highlightedDescription="Produkty jsou určeny pro klinické, diagnostické i výzkumné účely a pokrývají potřeby jak rutinních laboratoří, tak i vysoce specializovaných pracovišť."
	/>
	<ProductCategoryHeros {subcategories} />
</Layout>
